
<template>
	<BudgetDetailComponent v-if="contentType == 'budget'" :budgetId="contentId" />
	<MessagesFullView v-else-if="contentType == 'chatroom'" :selectedChatRoomId="contentId"/>
	<ContractDetailComponent v-else-if="isContractType" :contractId="contentId" :contractType="contentType"/>
</template>

<script>
import BudgetDetailComponent from '@/components/Views/Budgets/BudgetDetailComponent'
import ContractDetailComponent from '@/components/Views/Contracts/ContractDetailComponent'
import MessagesFullView from '@/components/Views/Chat/MessagesFullView'

export default {
	name: 'OnlyContent',
	components: { BudgetDetailComponent, ContractDetailComponent, MessagesFullView },
	computed: {
		contentType(){
			return this.$route.query.type
		},
		contentId(){
			return this.$route.query.id
		},
		isContractType(){
			return ['contract', 'addendum', 'subcontract'].includes(this.contentType)
		}
	},
}
</script>

<style>

</style>